import { DistributeReq, DistributeDef } from "../../type/trend";

export class DistributeAdapter {
  static toInputDTO(req: DistributeReq): any {
    const selectedNode = req.node_attrs.find((attr) => attr.value);
    return {
      node: selectedNode ? selectedNode.key : null,
    };
  }

  static toOutputDTO(res: any): DistributeDef {
    if (!res?.distributions) return [];

    // 系列キーは value_label を優先 (新DB: 20代/男性 等)。無い (legacy / avg) ときは生 label。
    const pick = (label: any, raw: any): any =>
      label != null && label !== "" ? String(label) : raw;

    return res.distributions.map((series: any, index: number) => {
      const seriesMaps = series.values.map((seriesObj: any) => {
        const map: { [date: number]: number } = {};
        if (seriesObj.x && seriesObj.prob_density) {
          for (let i = 0; i < seriesObj.x.length; i++) {
            const roundedDate = Math.round(seriesObj.x[i] * 10) / 10;
            map[roundedDate] = seriesObj.prob_density[i];
          }
        }
        return { label: pick(seriesObj.value_label, seriesObj.label), map };
      });

      const dateSet = new Set<number>();
      series.values.forEach((seriesObj: any) => {
        if (seriesObj.x) {
          seriesObj.x.forEach((d: number) =>
            dateSet.add(Math.round(d * 10) / 10)
          );
        }
      });

      const unionDates = Array.from(dateSet).sort((a, b) => a - b);

      const trend = unionDates.map((date) => {
        const obj: any = { datetime: date };

        seriesMaps.forEach((series: any) => {
          const value = series.map.hasOwnProperty(date)
            ? series.map[date]
            : null;
          obj[series.label] = value;
        });
        return obj;
      });

      return {
        id: index,
        key: series.key,
        values: trend,
      };
    });
  }
}
